import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="mt-auto py-8 border-t w-full" style={{ backgroundColor: 'var(--color-bg-secondary)', borderColor: 'var(--color-border)' }}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0">
            <Link to="/dashboard" className="font-bold navbarAppName">
              LearnYourself
            </Link>
            <p className="text-sm mt-2" style={{ color: 'var(--color-text-light)' }}>
              © {new Date().getFullYear()} LearnYourself. All rights reserved.
            </p>
          </div>
          <div className="flex">
            <Link to="/contact" className="text-sm mx-2" style={{ color: 'var(--color-text-light)' }}>
              Contact
            </Link>
            <Link to="/about" className="text-sm mx-2" style={{ color: 'var(--color-text-light)' }}>
              About
            </Link>
            <Link to="/privacy" className="text-sm mx-2" style={{ color: 'var(--color-text-light)' }}>
              Privacy
            </Link>
            <Link to="/terms" className="text-sm mx-2" style={{ color: 'var(--color-text-light)' }}>
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
